import { OperatorId } from '@entities/operator';

export default (product, filterModel) => {
    if(!filterModel) return true;
    return OperatorId.Travelata.includes(product.get('product').get('operator').id) && !!product.get('product')?.get('block');
};